import DeviceSizes from './DeviceSizes';

const scrollTopBtns = document.querySelectorAll(
	'#scroll-top, #scroll-top-tfbank-form'
);

if (scrollTopBtns.length) {
	window.addEventListener(
		'scroll',
		scrollFunction,
		{ passive: true }
	);

	scrollFunction();

	scrollTopBtns.forEach((btn) => {
		btn.addEventListener(
			'click',
			topFunction
		);
	});
}

function scrollFunction() {
	const isMobile =
		window.innerWidth < DeviceSizes.MD;

	const scrollTop =
		document.body.scrollTop ||
		document.documentElement.scrollTop;

	scrollTopBtns.forEach((btn) => {

		if (
			btn.classList.contains(
				'desktop-scroll-top'
			) && isMobile
		) {
			return;
		}

		if (
			btn.classList.contains(
				'mobile-scroll-top'
			) && !isMobile
		) {
			return;
		}

		btn.style.display =
			scrollTop > 1000
				? 'block'
				: 'none';
	});
}

function topFunction(e) {
	e.preventDefault();

	window.scrollTo({
		top: 0,
		behavior: 'smooth',
	});
}